module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_RO-fe4efd4bbcd75223cd964b83b3f295f7.svg";